import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { deleteCDocFile, getCDocFilesList } from "../Actions/ControlledDocAPI";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import AddIcon from "../UIComponents/AddIcon";
import { confirmAlert } from "react-confirm-alert";
import { OverlayTrigger, Popover } from "react-bootstrap";
import i18n from "./DropdownLanguage/i18n";

class ControlledDocView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                FolderId: 0,
                FileName: "",
                PageNumber: 1,
                PageSize: 20
            }
        }
        console.log(props);
        this.SearchDoc = this.SearchDoc.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        const { match, CDocFolderfiles } = this.props;
        console.log("DOC", CDocFolderfiles)
        let folderId = match.params.id;
        this.state.searchData.FolderId = folderId;
        this.props.dispatch({ type: 'SubBannerTitle', data: "Controlled Documents" });
        this.setState({}, () => {
            this.props.dispatch(getCDocFilesList(this.state.searchData))
        });
    }

    SearchDoc(pgno) {
        const { match, dispatch } = this.props;
        dispatch(getCDocFilesList(this.state.searchData));
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "File") {
            this.state.searchData.FileName = e.target.value;
        }
        this.setState({});
    }

    ClearInput() {
        const { match } = this.props;
        let folderId = match.params.id;
        this.setState({
            searchData: {
                FolderId: folderId,
                FileName: "",
                PageNumber: 1,
                PageSize: 20
            }
        }, () => {
            this.props.dispatch(getCDocFilesList(this.state.searchData))
        });
    }

    removeExtension(filename) {
        return filename.substring(0, filename.lastIndexOf('.')) || filename;
    }

    NewitemNav = () => {
        const { match } = this.props
        let folderId = match.params.id;
        this.props.history.push(`/Home/ControlledDocumentsView/${folderId}/FileAdd`);
    };

    deleteFile(item) {
        const { t } = this.props;
        confirmAlert({
            message: `${t("confirmAlertMessage.DeleteMsg")}`,
            buttons: [
                {
                    label: `${t("confirmAlertMessage.Yes")}`,
                    onClick: () => {
                        const { dispatch, match } = this.props;
                        let id = match.params.id;
                        dispatch(deleteCDocFile(id, item));
                    }
                },
                {
                    label: `${t("confirmAlertMessage.No")}`,
                    onClick: () => { }
                }
            ]
        });
    }
    renderedit(props) {
        return (
            <Popover id="history-tooltip" {...props}>
                <Popover.Content>
                    <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
                </Popover.Content>
            </Popover>
        );
    }

    renderdownload(props) {
        return (
            <Popover id="history-tooltip" {...props}>
                <Popover.Content>
                    <label style={{ padding: "0px 10px" }}>{this.props.t("ControlledDocumentsScreenContent.DownloadDocument")}</label>
                </Popover.Content>
            </Popover>
        );
    }

    render() {

        return (
            <div className="pb-3">
                {this.renderCardData()}
            </div>
        );
    }

    renderCardData() {
        const { CDocFolderfiles, t } = this.props;
        const isArabic = i18n.language === 'arab'
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='col-lg-12'>
                        <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-2"
                            onClick={() => this.hideSidePanel()}
                            style={{display:'inline-flex',alignItems:'center'}}
                        >
                           <span style={{marginTop:'-1px'}}>&larr;</span>{t("CommonText.Back")}
                        </button>
                        <div className="panel-box">
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                                    <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}>{CDocFolderfiles.folderName}</h5>
                                    < div className="m-1 flex" onClick={this.NewitemNav}>
                                        <span className="mt-1">{t("ShipManagementContent.Add")}</span><AddIcon />
                                    </div>
                                </div>
                            </div>
                            <div className="search-filter-box">
                                <div className="row">
                                    <div className={"col-lg-6"}>
                                        <label className="form-label" >{t("ControlledDocumentsScreenContent.File")}</label><br></br>
                                        <input className="form-control" type="text" name="File" value={this.state.searchData.FileName} placeholder={t("ControlledDocumentsScreenContent.File")} onChange={(e) => this.handleInputChange(e)}></input>
                                    </div>
                                    <div className={"col-lg-6"}>
                                        <br></br>
                                        <div className="form-group search-btn-col pt-3" style={{ textAlign: "end" }}>
                                            <button
                                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                type="submit"
                                                onClick={() => this.SearchDoc(1)}
                                            >
                                                {" "} {t("content.Search")}{" "}
                                            </button>
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button"
                                                onClick={() => this.ClearInput()}
                                            >
                                                {" "} {t("content.Clear")}{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {CDocFolderfiles.files && CDocFolderfiles.files.length ? CDocFolderfiles.files.map((item, index) => {
                            if (!item.isDeleted) {
                                return (
                                    <div className="card mb-2" style={{ backgroundColor: "white", overflow: "hidden", position: "relative" }}>
                                        <div className="p-3" >
                                            <div className="resource-list-auth-date">
                                                <div className="row">
                                                    <div className="col-sm-10 col-md-11 col-10 m-auto">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <span className={`${isArabic ? 'arabic' : ''}`}><strong>{t("ControlledDocumentsScreenContent.FileName")}  </strong>
                                                                <strong>:</strong>
                                                                    {this.removeExtension(`${item.fileName}`)}
                                                                </span>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <span className={`${isArabic ? 'arabic_ship' : ''}`}><strong>{t("FlagScreen.Attachment")}  </strong>
                                                                <strong>:</strong>
                                                                    {item.fileName}
                                                                </span>
                                                                {item.fileName ?
                                                                    <OverlayTrigger
                                                                        placement="bottom"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={this.renderdownload()}
                                                                    >
                                                                        <i className="fa fa-download click ml-1"
                                                                            onClick={() => this.DownloadDoc(item.fileName, item.fileGuid)} aria-hidden="true" style={{ color: ' #1a3464', fontSize: "1.2rem" }}></i>
                                                                    </OverlayTrigger>
                                                                    : ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2 col-md-1 col-2 m-auto">
                                                        <div className="text-center">
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                delay={{ show: 250, hide: 400 }}
                                                                overlay={this.renderedit()}
                                                            >
                                                                <i className="fa fa-trash fa-2x click ml-1" style={{ marginLeft: '-15px' }}
                                                                    onClick={() => this.deleteFile(item)}
                                                                ></i>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })
                            :
                            <div className="card m-2" style={{ overflow: "hidden", position: "relative" }}>
                                <div className="container">
                                    <h6 className="resource-list-title no-item-card">
                                        {t("CommonText.DocumentMsg")}
                                    </h6>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div >
        )
    }
    hideSidePanel() {
        const { dispatch, history } = this.props;;
        dispatch({ type: "ShowSidePan", data: false });
        history.push('/Home/ControlledDocuments');
    }

    DownloadDoc(fileName, fileGuid) {
        this.props.dispatch(DownloadAttachment(fileName, fileGuid));
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        CDocFolderfiles: state.ControlledDocReducer.CDocFolderfiles || [],
    }
}
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(ControlledDocView)));